var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import { FormattedMessage } from "@irati/utils/lang";
import perksGOBadge from "@irati-web/perksgo/src/images/perksGO_badge.svg";
import LinkCardPopup from "@irati-web/perksgo/src/components/Popup/LinkCard";
import { Body, H3 } from "@irati/ui/src/Typography";
import { StyledButton, Image, ImageTextWrapper, GridWrapper, StyledRouterLink } from "./styled/CategoryHeaders";
var EarnCategoryHeader = /** @class */ (function (_super) {
    __extends(EarnCategoryHeader, _super);
    function EarnCategoryHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            hasLinkedCards: undefined
        };
        _this.findOutMorePopup = React.createRef();
        _this.componentDidMount = function () {
            _this.setState({ load: _this.hasLinkedCards() });
        };
        _this.hasLinkedCards = function () {
            var userId = authentication.user().uuid;
            return linkedCardService.getPerksGOCards({ userId: userId }).then(function (linkedCards) {
                _this.setState({ hasLinkedCards: linkedCards.length > 0 });
            });
        };
        _this.handleLinkCardButtonClick = function () {
            _this.findOutMorePopup.current.wrappedInstance.show();
        };
        return _this;
    }
    EarnCategoryHeader.prototype.render = function () {
        var _a = this.props, className = _a.className, onButtonClick = _a.onButtonClick;
        var _b = this.state, hasLinkedCards = _b.hasLinkedCards, load = _b.load;
        var apps = this.context.apps;
        return (React.createElement(Loading, { load: load },
            React.createElement(GridWrapper, { className: className },
                React.createElement(ImageTextWrapper, null,
                    React.createElement(Image, { src: perksGOBadge }),
                    React.createElement("div", null,
                        React.createElement(H3, { paddingBottom: 0.5 },
                            React.createElement(FormattedMessage, { id: "perks.categories.earnCategoryHeader.title" })),
                        React.createElement(Body, { small: true, overflow: "hidden" },
                            React.createElement(FormattedMessage, { id: "perks.categories.earnCategoryHeader.subText" })))),
                hasLinkedCards ? (React.createElement(StyledRouterLink, { primary: true, full: true, to: "/perks/location", app: apps.SEARCH, onClick: onButtonClick },
                    React.createElement(FormattedMessage, { id: "perks.categories.earnCategoryHeader.buttonText" }))) : (React.createElement(StyledButton, { primary: true, full: true, onClick: this.handleLinkCardButtonClick },
                    React.createElement(FormattedMessage, { id: "perks.categories.earnCategoryHeader.noCardsButtonText" })))),
            React.createElement(LinkCardPopup, { ref: this.findOutMorePopup })));
    };
    EarnCategoryHeader.defaultProps = {
        className: null,
        onButtonClick: function () { }
    };
    EarnCategoryHeader.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return EarnCategoryHeader;
}(PureComponent));
export default EarnCategoryHeader;
